// if (!customElements.get('media-gallery')) {
//   customElements.define(
//     'media-gallery',
//     class MediaGallery extends HTMLElement {
//       constructor() {
//         super();
//         this.elements = {
//           liveRegion: this.querySelector('[id^="GalleryStatus"]'),
//           viewer: this.querySelector('[id^="GalleryViewer"]'),
//           thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
//         };
//         this.mql = window.matchMedia('(min-width: 768px)');
//         if (!this.elements.thumbnails) return;

//         this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
//         this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
//           mediaToSwitch
//             .querySelector('button')
//             .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target));
//         });
//         if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
//       }
//       // onSlideChanged(event) {
//       //   if (event.detail && event.detail.currentElement) {
//       //     const currentElement = event.detail.currentElement;
//       //     if (currentElement.dataset && currentElement.dataset.mediaId) {
//       //       const thumbnail = this.elements.thumbnails.querySelector(
//       //         `[data-target="${currentElement.dataset.mediaId}"]`
//       //       );
//       //       this.setActiveThumbnail(thumbnail);
//       //     }
//       //   }
//       // }
//       onSlideChanged(event) {
//         if (event.detail && event.detail.currentElement) {
//           const currentElement = event.detail.currentElement;
//           if (currentElement.dataset && currentElement.dataset.mediaId) {
//             // Prevent resetting to the first image if a variant was selected
//             if (this.elements.viewer.dataset.selectedMediaId && 
//                 this.elements.viewer.dataset.selectedMediaId !== currentElement.dataset.mediaId) {
//                 return;
//             }
//             const thumbnail = this.elements.thumbnails.querySelector(
//                 `[data-target="${currentElement.dataset.mediaId}"]`
//             );
//             this.setActiveThumbnail(thumbnail);
//           }
//         }
//       }
      
//       setActiveMedia(mediaId) {
//         const activeMedia =
//           this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
//           this.elements.viewer.querySelector('[data-media-id]');
//         if (!activeMedia) {
//           return;
//         }
//         this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
//           element.classList.remove('is-active');
//         });
//         activeMedia?.classList?.add('is-active');

//         this.preventStickyHeader();
//         window.setTimeout(() => {
//           if (!this.mql.matches || this.elements.thumbnails) {
//             activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
//           }
//           const activeMediaRect = activeMedia.getBoundingClientRect();
//           // Don't scroll if the image is already in view
//           if (activeMediaRect.top > -0.5) return;
//           const top = activeMediaRect.top + window.scrollY;
//           window.scrollTo({ top: top, behavior: 'smooth' });
//         });
//         this.playActiveMedia(activeMedia);

//         if (!this.elements.thumbnails) return;
//         const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
//         if (activeThumbnail) {
//           this.setActiveThumbnail(activeThumbnail);
//         }
//         this.elements.viewer.dataset.selectedMediaId = mediaId;
//         if (activeThumbnail) {
//           this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
//         }
//       }

//       setActiveThumbnail(thumbnail) {
//         if (!this.elements.thumbnails || !thumbnail) return;

//         this.elements.thumbnails
//           .querySelectorAll('button')
//           .forEach((element) => element.removeAttribute('aria-current'));
//         thumbnail.querySelector('button').setAttribute('aria-current', true);
//         if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
//         this.elements.thumbnails.setSlidePosition(thumbnail[this.elements.thumbnails.offsetLeft]);
//       }

//       announceLiveRegion(activeItem, position) {
//         const image = activeItem.querySelector('.product__modal-opener--image img');
//         if (!image) return;
//         image.onload = () => {
//           this.elements.liveRegion.setAttribute('aria-hidden', false);
//           this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
//           setTimeout(() => {
//             this.elements.liveRegion.setAttribute('aria-hidden', true);
//           }, 2000);
//         };
//         image.src = image.src;
//       }

//       playActiveMedia(activeItem) {
//         window.pauseAllMedia();
//         const deferredMedia = activeItem.querySelector('.deferred-media');
//         if (deferredMedia) deferredMedia.loadContent(false);
//       }

//       preventStickyHeader() {
//         this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
//         if (!this.stickyHeader) return;
//         this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
//       }

//       removeListSemantic() {
//         if (!this.elements.viewer.slider) return;
//         this.elements.viewer.slider.setAttribute('role', 'presentation');
//         this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
//       }
//     }
//   );
// }
if (!customElements.get('media-gallery')) {
    customElements.define(
        'media-gallery',
        class MediaGallery extends HTMLElement {
            constructor() {
                super();

                this.elements = {
                    liveRegion: this.querySelector('[id^="GalleryStatus"]'),
                    viewer: this.querySelector('[id^="GalleryViewer"]'),
                    thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),

                    // bullets
                    bullets: this.querySelector('.slider-bullets'),
                };

                this.mql = window.matchMedia('(min-width: 768px)');

                if (!this.elements.viewer) return;

                // swipe product media on mobile to change active bullet state logic
                if (this.elements.viewer.slider) {
                    this.elements.viewer.slider.addEventListener(
                        'scroll',
                        debounce(() => {
                            const slider = this.elements.viewer.slider;

                            const slides = slider.querySelectorAll('[data-media-id]');

                            if (!slides.length) return;

                            let closestSlide = null;
                            let closestDistance = Infinity;

                            slides.forEach((slide) => {
                                const distance = Math.abs(
                                    slide.offsetLeft - slider.scrollLeft
                                );

                                if (distance < closestDistance) {
                                    closestDistance = distance;
                                    closestSlide = slide;
                                }
                            });

                            if (!closestSlide) return;

                            const mediaId = closestSlide.dataset.mediaId;

                            if (!mediaId) return;

                            this.setActiveBullet(mediaId);
                        }, 50)
                    );
                }

                if (this.elements.thumbnails) {
                    this.elements.thumbnails
                        .querySelectorAll('[data-target]')
                        .forEach((mediaToSwitch) => {
                            mediaToSwitch
                                .querySelector('button')
                                .addEventListener(
                                    'click',
                                    this.setActiveMedia.bind(
                                        this,
                                        mediaToSwitch.dataset.target
                                    )
                                );
                        });
                }

                if (this.elements.bullets) {
                    this.elements.bullets
                        .querySelectorAll('.slider-bullet')
                        .forEach((bullet) => {
                            bullet.addEventListener('click', () => {
                                this.setActiveMedia(bullet.dataset.target);
                            });
                        });
                }


                if (
                    this.dataset.desktopLayout.includes('thumbnail') &&
                    this.mql.matches
                ) {
                    this.removeListSemantic();
                }


            }


            // onSlideChanged(event) {
            //   if (event.detail && event.detail.currentElement) {
            //     const currentElement = event.detail.currentElement;
            //     if (currentElement.dataset && currentElement.dataset.mediaId) {
            //       const thumbnail = this.elements.thumbnails.querySelector(
            //         `[data-target="${currentElement.dataset.mediaId}"]`
            //       );
            //       this.setActiveThumbnail(thumbnail);
            //     }
            //   }
            // }

            setActiveMedia(mediaId) {
                const activeMedia =
                    this.elements.viewer.querySelector(
                        `[data-media-id="${mediaId}"]`
                    );

                if (!activeMedia) {
                    return;
                }

                this.elements.viewer
                    .querySelectorAll('[data-media-id]')
                    .forEach((element) => {
                        element.classList.remove('is-active');
                    });

                activeMedia.classList.add('is-active');

                this.preventStickyHeader();

                window.setTimeout(() => {
                    if (!this.mql.matches || this.elements.thumbnails) {
                        activeMedia.parentElement.scrollTo({
                            left: activeMedia.offsetLeft,
                        });
                    }

                    const activeMediaRect =
                        activeMedia.getBoundingClientRect();

                    if (activeMediaRect.top > -0.5) return;

                    const top =
                        activeMediaRect.top + window.scrollY;

                    window.scrollTo({
                        top: top,
                        behavior: 'smooth',
                    });
                });

                this.playActiveMedia(activeMedia);

                // // Update thumbnail if available
                if (this.elements.thumbnails) {
                    const activeThumbnail =
                        this.elements.thumbnails.querySelector(
                            `[data-target="${mediaId}"]`
                        );

                    if (activeThumbnail) {
                        this.setActiveThumbnail(activeThumbnail);

                        this.announceLiveRegion(
                            activeMedia,
                            activeThumbnail.dataset.mediaPosition
                        );
                    }
                }

                // Update bullet
                this.setActiveBullet(mediaId);
            }

            setActiveBullet(mediaId) {
                if (!this.elements.bullets || !mediaId) return;

                const bullets =
                    this.elements.bullets.querySelectorAll('.slider-bullet');

                bullets.forEach((bullet) => {
                    const isActive =
                        bullet.dataset.target === mediaId;

                    bullet.classList.toggle('is-active', isActive);
                });
            }

            setActiveThumbnail(thumbnail) {
                if (!this.elements.thumbnails || !thumbnail) return;

                this.elements.thumbnails
                    .querySelectorAll('button')
                    .forEach((element) =>
                        element.removeAttribute('aria-current')
                    );

                thumbnail
                    .querySelector('button')
                    .setAttribute('aria-current', true);

                if (
                    this.elements.thumbnails.isSlideVisible(
                        thumbnail,
                        10
                    )
                ) {
                    return;
                }

                this.elements.thumbnails.setSlidePosition(
                    thumbnail[this.elements.thumbnails.offsetLeft]
                );
            }

            announceLiveRegion(activeItem, position) {
                const image = activeItem.querySelector(
                    '.product__modal-opener--image img'
                );

                if (!image) return;

                image.onload = () => {
                    this.elements.liveRegion.setAttribute(
                        'aria-hidden',
                        false
                    );

                    this.elements.liveRegion.innerHTML =
                        window.accessibilityStrings.imageAvailable.replace(
                            '[index]',
                            position
                        );

                    setTimeout(() => {
                        this.elements.liveRegion.setAttribute(
                            'aria-hidden',
                            true
                        );
                    }, 2000);
                };

                image.src = image.src;
            }

            playActiveMedia(activeItem) {
                window.pauseAllMedia();

                const deferredMedia =
                    activeItem.querySelector('.deferred-media');

                if (deferredMedia) {
                    deferredMedia.loadContent(false);
                }
            }

            preventStickyHeader() {
                this.stickyHeader =
                    this.stickyHeader ||
                    document.querySelector('sticky-header');

                if (!this.stickyHeader) return;

                this.stickyHeader.dispatchEvent(
                    new Event('preventHeaderReveal')
                );
            }

            removeListSemantic() {
                if (!this.elements.viewer.slider) return;

                this.elements.viewer.slider.setAttribute(
                    'role',
                    'presentation'
                );

                this.elements.viewer.sliderItems.forEach((slide) =>
                    slide.setAttribute(
                        'role',
                        'presentation'
                    )
                );
            }
        }
    );
}